import clsx from 'clsx'
import { FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material'

import { useAddRemoveParticipant } from '../../../providers/AddRemoveParticipantProvider'

import useStyles from './styles'

const AgentClientSearchToggle = () => {
  const classes = useStyles()
  const { options = [], setSearch, search } = useAddRemoveParticipant()

  const onChange = val => {
    setSearch(val)
  }

  if (options.length <= 1) {
    return null
  }

  return (
    <FormControl className={classes.control}>
      <RadioGroup
        name={''}
        value={search}
        onChange={e => onChange(e.target.value)}
        style={{ flexDirection: 'row', justifyContent: 'center' }}
      >
        {options.map((val, i) => (
          <FormControlLabel
            key={i}
            value={val}
            label={val}
            control={
              <Radio color='primary' size='small' className={classes.radio} />
            }
            className={clsx(
              classes.controlLabel,
              val === search && classes.controlLabelBold
            )}
          />
        ))}
      </RadioGroup>
    </FormControl>
  )
}

export default AgentClientSearchToggle
